import { createPortal } from "react-dom";
import { ReactNode, useEffect, useState } from "react";

export const Portal = ({ children }: { children: ReactNode }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768 || window.matchMedia("(orientation: portrait)").matches;
      setIsMobile(mobile);
    };

    checkMobile();

    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return isMobile ? createPortal(children, document.body) : <>{children}</>;
};
